import React from 'react';
import {
  BonusParagraph,
  TaxParagraph,
} from '../carrelloFooter/carrelloFooterVincitaInfoRow/CarrelloFooterVincitaInfoRow';
import { isGermanSite, isSnaiSite } from 'utility/constant';
import {
  selectDescrizioneLastAvvenimentoAddedByTicket,
  selectErrorLabels,
  selectErroriByTicket,
  selectIsFullCart,
  selectLastScommessa,
  selectNumEsitiByTicketType,
  selectPuntataSingolaMultiplaByTicketType,
} from '../carrelloSelectors';
import { useAppDispatch, useTypedSelector } from 'lib/centralStore';

import { CarrelloActionPrenotazione } from 'features/carrello/carrelloActionPrenotazione';
import { CarrelloEditQuotaInput } from 'features/carrello/carrelloEditQuotaInput';
import { CarrelloFooterActionsRow } from 'features/carrello/carrelloFooter/carrelloFooterActionsRow';
import { CarrelloFooterAvvenimentoInfoRow } from 'features/carrello/carrelloFooter/carrelloFooterAvvenimentoInfoRow';
import { CarrelloFooterSimpleInfoRow } from 'features/carrello/carrelloFooter/carrelloFooterSimpleInfoRow';
import { CarrelloFooterTitleRow } from 'features/carrello/carrelloFooter/carrelloFooterTitleRow';
import { CarrelloFooterVincitaInfoRow } from 'features/carrello/carrelloFooter/carrelloFooterVincitaInfoRow';
import { CarrelloPopoverMenu } from 'features/carrello/carrelloPopoverMenu';
import { MovimentiTipoScommessaEnum } from 'types/swagger';
import { TipoCarrello } from 'features/carrello/carrelloFooter/carrelloFooterTitleRow/CarrelloFooterTitleRow';
import classNames from 'classnames';
import { isCarrelloTypeSport } from 'features/carrello/utils';
import { shallowEqual } from 'react-redux';
import styles from './CarrelloFooterSingolaMultipla.module.scss';
import { toggleOpenSettings } from 'features/sport/components/sportTicket/sportTicketSlice';
import { useGetLabelByKey } from 'hooks/useLingUI';
import { useInternalSession } from 'hooks/useInternalSession';

export type CarrelloFooterSingolaMultiplaProps = {
  quotaTotale: number;
  bonus: number;
  possibileVincita: number;
  possibileVincitaconBonus?: number;
  isMultipla?: boolean;
  type: MovimentiTipoScommessaEnum;
  hasSettings?: boolean;
};

export const CarrelloFooterSingolaMultipla = ({
  type,
  bonus,
  quotaTotale,
  hasSettings,
  isMultipla,
  possibileVincita,
  possibileVincitaconBonus,
}: CarrelloFooterSingolaMultiplaProps) => {
  const dispatch = useAppDispatch();
  const { isAuthenticated } = useInternalSession();
  const errori = useTypedSelector((state) => selectErroriByTicket(state, type));
  const numEsiti = useTypedSelector((state) => selectNumEsitiByTicketType(state, type));
  const descrizioneLastAvvenimentoAdded = useTypedSelector((state) =>
    selectDescrizioneLastAvvenimentoAddedByTicket(state, type)
  );
  const lastScommessaAdded = useTypedSelector((state) => selectLastScommessa(state, type));
  const taxes = useTypedSelector((state) => state.sportTicket.taxes);
  const tax = useTypedSelector((state) => state.sportTicket.ticket?.tax);
  const isFullCart = useTypedSelector(selectIsFullCart);
  const errorsLabels = useTypedSelector(selectErrorLabels);

  const puntataSingolaMultipla = useTypedSelector(
    (state) => selectPuntataSingolaMultiplaByTicketType(state, type),
    shallowEqual
  );

  const labelQuota = useGetLabelByKey('quota-totale');
  const labelVincitaPotenziale = useGetLabelByKey('vincita-potenziale');
  const labelBonus = useGetLabelByKey('con-bonus');
  const labelWarning = useGetLabelByKey('scommetti-altro-per-bonus');
  const labelPrenota = useGetLabelByKey('prenota');
  const labelImpostazioniScommessa = useGetLabelByKey('impostazioni-scommessa');

  return (
    <div className={styles.container}>
      {!isFullCart && (
        <React.Fragment>
          {/* TODO label */}
          {isMultipla ? (
            <CarrelloFooterTitleRow
              tipoCarrello={TipoCarrello.Multipla}
              numItem={numEsiti || 0}
              hasOnlyHorizontalPadding
            />
          ) : (
            descrizioneLastAvvenimentoAdded &&
            lastScommessaAdded && (
              <CarrelloFooterAvvenimentoInfoRow
                competitors={descrizioneLastAvvenimentoAdded}
                scommessa={{
                  esito: lastScommessaAdded.esito,
                  quota: lastScommessaAdded.quota,
                  tipoScommessa: lastScommessaAdded.tipoScommessa,
                  tipoScommessaTrKey: lastScommessaAdded.tipoScommessaTrKey,
                }}
                hasOnlyHorizontalPadding
              />
            )
          )}
        </React.Fragment>
      )}

      {(isFullCart || (!isFullCart && isMultipla)) && (
        <CarrelloFooterSimpleInfoRow label={labelQuota!} value={String(quotaTotale)} hasOnlyHorizontalPadding />
      )}

      <div className={styles.row}>
        <CarrelloEditQuotaInput hasBtn defaultValue={+puntataSingolaMultipla} hasAction />

        {hasSettings && isAuthenticated && (
          <CarrelloPopoverMenu containerClassname={styles.settings}>
            <button type="button" className={styles.button} onClick={() => dispatch(toggleOpenSettings(true))}>
              {labelImpostazioniScommessa}
            </button>
          </CarrelloPopoverMenu>
        )}
      </div>

      {((!isSnaiSite && isGermanSite) || (!isSnaiSite && isAuthenticated)) && (
        <TaxParagraph
          percApplicata={tax}
          percReale={taxes?.taxAppliedSingle}
          hasPadding
          quota={+puntataSingolaMultipla}
          isMultipla={numEsiti > 1}
        />
      )}

      {errori.messaggi.length > 0 && (
        <React.Fragment>
          {Array.from(errori.messaggi, (errore, index) => {
            const foundErrors = errorsLabels?.find((errorLabel) => errorLabel.key === errore);

            if (foundErrors) {
              return <BonusParagraph key={`${foundErrors?.key}-${index}`} bonusLabel={foundErrors?.value} hasPadding />;
            } else return null;
          })}
        </React.Fragment>
      )}

      <CarrelloFooterVincitaInfoRow
        label={labelVincitaPotenziale!}
        value={String(possibileVincita.toFixed(2))}
        bonus={bonus}
        bonusLabel={labelBonus}
        bonusValue={String(possibileVincitaconBonus?.toFixed(2))}
        warningLabel={labelWarning}
        hasOnlyHorizontalPadding
      />

      {isFullCart && isCarrelloTypeSport(type) && !isAuthenticated && (
        <CarrelloFooterActionsRow hasOnlyHorizontalPadding>
          <CarrelloActionPrenotazione
            btnClassName={classNames({ [styles.prenotazioneBtn]: hasSettings })}
            btnLabel={labelPrenota!}
            disabled={!!isAuthenticated}
          />
          {/* {hasSettings && isAuthenticated && (
            <CarrelloPopoverMenu>
              {isAuthenticated && (
                <button type="button" onClick={() => dispatch(toggleOpenSettings(true))}>
                  {labelImpostazioniScommessa}
                </button>
              )}
            </CarrelloPopoverMenu>
          )} */}
        </CarrelloFooterActionsRow>
      )}
    </div>
  );
};
